
define('app/dashboard/leagues/instances/views/lgInstAdvView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/productModel',
	
	//Shims
	'jquery.uniform',
	'bootstrap.switch'
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		LeagueInstanceModel,
		ProductModel){
	
	var AdvanceLeagueFooterView = Backbone.View.extend({
		events: {
			'click #advLgFormSubmit': 'submitAdvLeagueForm',
			'click #advLgFormCancel': 'cancelAdvLeagueForm',
		},
		
		initialize: function(options) {
			this.event = options.event;
			this.lgInstance = options.lgInstance;
			
			this.showAdvLeagueForm();
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.showAdvLeagueForm);
			this.listenTo(this.event, 'success', this.hideAll);
			this.listenTo(this.event, 'cancel', this.closeAdvLeagueForm);
			
			this.listenTo(this.event, 'defaultRadioSelected', this.closeAdvLeagueForm);
			this.listenTo(this.event, 'radioChanged', this.showAdvLeagueForm);
		},
		
		hideAll: function () {
			this.$("#advLgFormSubmit").hide();
			this.$("#advLgFormCancel").hide();
			this.$("#advLgFooterSetupWarning").hide();
			this.$("#advLgFooterNormalWarning").hide();
		},
		
		submitAdvLeagueForm: function () {
			this.event.trigger("save");
		},
		
		cancelAdvLeagueForm: function () {
			this.event.trigger("cancel");
			this.event.trigger("resetMessages");
		},
		
		closeAdvLeagueForm: function () {
			$(this.el).slideUp();
		},
		
		showAdvLeagueForm: function () {
			this.hideAll();
			
			if(this.lgInstance.get("draftStatus") == "SETUP"){
				this.$("#advLgFooterSetupWarning").show();
			} else {
				this.$("#advLgFooterNormalWarning").show();
			}
			
			this.$("#advLgFormSubmit").show();
			this.$("#advLgFormCancel").show();
			
			$(this.el).slideDown();
		}
	});

	var AdvanceLeagueContentView = Backbone.View.extend({	
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			this.submittedData = options.submittedData;
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.prodConfig = options.prodConfig;
			this.prodType = options.prodType;
			
			this.firstRender = true;
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			_.bindAll(this, 'inputChange');
			
			this.listenTo(this.event, 'save', this.submitLeague);
			this.listenTo(this.event, 'default', this.leagueForm);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.leagueForm);
			this.listenTo(this.event, 'success', this.render);
			this.listenTo(this.event, 'cancel', this.resetRadioInputs);
			
			//Error handling
			this.listenTo(this.event, 'error:draftstatus', this.errorStatus);
		},
		
		render: function() {
			this.setupRadioInputs();
			this.resetRadioInputs();
			this.leagueForm();
		},
		
		submitLeague: function () {
			this.event.trigger("saving");
			var status = null;
			
			var keeperModeSelected = this.$("#advLgStatusPredraft").bootstrapSwitch('state');
			var draftModeSelected = this.$("#advLgStatusStart").bootstrapSwitch('state');
			
			if(keeperModeSelected && !draftModeSelected){
				status = "PREDRAFT";
			} else if(!keeperModeSelected && draftModeSelected){
				status = "STARTED";
			}
			
			if (!status	|| status == ""){
				this.event.trigger("error");
				this.event.trigger("error:draftstatus", "NULL");
			} else if(!this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = true;
				this.lgInstance.save({
					draftStatus: status
				},{wait: true,
					success : this.successCallback, 
					error : this.errorCallback
				});
			}
		},
		
		successCallback: function(model, response) {
			this.event.trigger("savingSuccess", model, response);
		},
		
		errorCallback: function(model, error) {
			this.event.trigger("savingError", model, error);
		},
		
		setupRadioInputs: function() {
			if(!this.firstRender){
				$(this.el).find("[name='advLgStatus']").bootstrapSwitch('destroy');
			} else {
				this.firstRender = false;
			}			
			
			$(this.el).find("[name='advLgStatus']").bootstrapSwitch();
			
			$(this.el).find("[name='advLgStatus']").on('switch-change', this.inputChange);
			
			//Disable keepers if it isn't available
			if(this.prodConfig.KEEPERS == 'true'){
				this.$("#advLgPredraftRadioLabel").html('Keeper Mode');		
				this.$("#advLgStatusPredraft").removeProp('disabled');
				//this.$("#advLgPredraftRadio").removeClass('disabled');
				this.$("#advLgStatusPredraft").bootstrapSwitch('setDisabled', false);
			} else {
				this.$("#advLgPredraftRadioLabel").html('Keeper Mode (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
				this.$("#advLgStatusPredraft").prop('disabled', 'disabled');
				//this.$("#advLgPredraftRadio").addClass('disabled');
				this.$("#advLgStatusPredraft").bootstrapSwitch('setDisabled', true);
			}			
		},
		
		resetRadioInputs: function() {
			//Set radio values
			switch (this.lgInstance.get("draftStatus")) {
			case "SETUP":
				$(this.el).find("[name='advLgStatus']").bootstrapSwitch('toggleRadioStateAllowUncheck', true);
				this.$("#advLgStatusPredraft").bootstrapSwitch('setState', false);
				this.$("#advLgStatusStart").bootstrapSwitch('setState', false);
				break;
			case "PREDRAFT":
				$(this.el).find("[name='advLgStatus']").bootstrapSwitch('toggleRadioStateAllowUncheck', false);
				this.$("#advLgStatusPredraft").bootstrapSwitch('setState', true);
				this.$("#advLgStatusStart").bootstrapSwitch('setState', false);
				break;
			case "STARTED":
				$(this.el).find("[name='advLgStatus']").bootstrapSwitch('toggleRadioStateAllowUncheck', false);
				this.$("#advLgStatusPredraft").bootstrapSwitch('setState', false);
				this.$("#advLgStatusStart").bootstrapSwitch('setState', true);
				break;
			default:
				break;
			}
		},
		
		inputChange: function() {			
			//Set radio values
			switch (this.lgInstance.get("draftStatus")) {
			case "SETUP":
				$(this.el).find("[name='advLgStatus']").bootstrapSwitch('toggleRadioStateAllowUncheck', true);
				
				var keeperModeSelected = this.$("#advLgStatusPredraft").bootstrapSwitch('state');
				var draftModeSelected = this.$("#advLgStatusStart").bootstrapSwitch('state');
				
				if(!keeperModeSelected && !draftModeSelected){
					this.event.trigger("defaultRadioSelected");
				} else {
					this.event.trigger("radioChanged");
				}
				
				break;
			case "PREDRAFT":
				$(this.el).find("[name='advLgStatus']").bootstrapSwitch('toggleRadioStateAllowUncheck', false);
				
				var keeperModeSelected = this.$("#advLgStatusPredraft").bootstrapSwitch('state');
				var draftModeSelected = this.$("#advLgStatusStart").bootstrapSwitch('state');
				
				if(keeperModeSelected && !draftModeSelected){
					this.event.trigger("defaultRadioSelected");
				} else {
					this.event.trigger("radioChanged");
				}
				
				break;
			case "STARTED":
				$(this.el).find("[name='advLgStatus']").bootstrapSwitch('toggleRadioStateAllowUncheck', false);
				
				var keeperModeSelected = this.$("#advLgStatusPredraft").bootstrapSwitch('state');
				var draftModeSelected = this.$("#advLgStatusStart").bootstrapSwitch('state');
				
				if(!keeperModeSelected && draftModeSelected){
					this.event.trigger("defaultRadioSelected");
				} else {
					this.event.trigger("radioChanged");
				}
				
				break;
			default:
				break;
			}
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			//Hide error messages
			this.$("#advLgPredraftRadio").removeClass("error");
			this.$("#advLgPredraftStart").removeClass("error");
			this.$("#advLgStatusErrMsg").hide();
		},
		
		leagueForm: function () {
			this.hideAll();
			
			//Determine whether to show the form
			if(this.lgInstance.isCommissioner(this.userModel.get('userName'))
					&& this.lgInstance.get("draftStatus") != "COMPLETED"
					&& this.prodType.get('active')){
				$(this.el).show();
			} else {
				$(this.el).hide();
			}
		},
		
		errorStatus : function (errorCode) {
			this.$("#advLgPredraftRadio").addClass("error");
			this.$("#advLgPredraftStart").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#advLgStatusErrMsg").html("Draft status is empty");
					this.$("#advLgStatusErrMsg").show();
					break;
				default : 
					this.$("#advLgStatusErrMsg").html("Draft status is invalid");
					this.$("#advLgStatusErrMsg").show();
			}
		}
	});

	var AdvanceLeagueMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'resetMessages', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.success);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$("#advLgBodyMessageError").hide();
			this.$("#advLgBodyMessageProcessing").hide();
			this.$("#advLgBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#advLgBodyMessageError").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#advLgBodyMessageSuccess").show();
			this.$("#advLgBodyMessageSuccess").fadeOut(3000);
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#advLgBodyMessageProcessing").show();
		}
	});
	
	var AdvanceLeagueView = Backbone.View.extend({
		el: $("#advLgContent"),
		
		initialize: function(options) {		
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.prodConfig = options.prodConfig;
			this.prodType = options.prodType;
			
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			this.message = new AdvanceLeagueMessageView({el: this.$("#advLgBodyMessage"), event: this.event});
			this.content = new AdvanceLeagueContentView({
				el: this.$("#advLgBodyContent"), 
				event: this.event,
				submittedData : this.submittedData,
				userModel: this.userModel, 
				lgInstance: this.lgInstance,
				prodConfig: this.prodConfig,
				prodType: this.prodType});
			this.footer = new AdvanceLeagueFooterView({el: this.$("#advLgFooter"), event: this.event, lgInstance: this.lgInstance});
			
			this.listenTo(this.event, 'savingSuccess', this.advLgSuccess);
			this.listenTo(this.event, 'savingError', this.advLgError);
		},
		
		render: function () {
			this.updateVisuals();
			this.content.render();
			
			this.event.trigger("default");
			return this;
		},
		
		updateVisuals: function() {
			$(this.el).find('#lgInfoStatus').html(this.lgInstance.prettyStatus());
			
			this.$("#advLgViewBoard").show();
			this.$("#advLgViewBoard").attr("href", '/draftapp/board/' + this.lgInstance.get('id'));
		},
		
		advLgError: function(model, error) {
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		advLgSuccess: function () {
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				this.event.trigger("success");
			}
			
			this.updateVisuals();
			//this.model.trigger("reset");			
		}
	});
	
	return AdvanceLeagueView;  
});